/* eslint-disable react/prop-types */
/**
 * 服务交付 · 两张明细表的列定义
 * ------------------------------------------------------------------
 * 列定义外置（重构方案 §4.3）：页面只留取数与组合。
 *
 * 契约提醒：`DataTable` 的 `empty` 占位只作用于**它自己生成的** render
 * （即只给 `format`/`unit` 的列）。一旦本文件自己写了 `render`，
 * 空值就要自己兜底 —— 所以下面带自定义 render 的列都显式判空。
 */
import React from 'react';
import { Avatar } from 'antd';

import styles from '../board.less';

/** 会员入口链接：两处表格的「会员详情 / 会员档案」跳转完全同构，只差文案 */
const MemberLink = ({ userId, children }) => (
  <a
    href={`/litta-palmer/user/record?id=${userId}`}
    target="_blank"
    rel="noreferrer"
  >
    {children}
  </a>
);

/** 完课会员列表（dateRange=今天/昨天 时展示；源不给按日聚合，故只出明细） */
export const completionMemberColumns = [
  {
    title: '会员昵称',
    dataIndex: 'nickName',
    render: (v, record) => (
      <span className={styles.cellUser}>
        <Avatar size={28} src={record.avatar || undefined}>
          {(v || '?').slice(0, 1)}
        </Avatar>
        {v || '--'}
      </span>
    ),
  },
  { title: '训练开始时间', dataIndex: 'startTime', width: 180 },
  { title: '训练时长', dataIndex: 'duration', width: 120 },
  { title: '课程名称', dataIndex: 'className' },
  {
    title: '操作',
    key: 'op',
    width: 100,
    render: (record) => (
      <MemberLink userId={record.userId}>会员详情</MemberLink>
    ),
  },
];

/** 会员课时明细（服务端筛选 + 服务端分页） */
export const courseDetailColumns = [
  {
    title: '会员姓名',
    dataIndex: 'nickName',
    render: (v, record) => (
      <span className={styles.cellUser}>
        <Avatar size={32} src={record.avatar || undefined}>
          {(v || '?').slice(0, 1)}
        </Avatar>
        {v || '--'}
      </span>
    ),
  },
  {
    title: '剩余课时',
    dataIndex: 'remainNum',
    width: 120,
    /* 右对齐 + 等宽（数值列不跳动） */
    numeric: true,
    /*
     * 故意不做 sorter：本表已是服务端分页（源 listRights 无排序参数，
     * 只有 expireType / lastClassType / minRemainingClassNum / search），
     * 本地 comparator 只能排当页，排序图标会误导为「全量可排」。
     * 要真排序需 merchant 侧支持排序字段（契约 G8）。
     */
    render: (v) => {
      if (v === undefined || v === null || v === '') return '--';
      /* 少于 5 节标红。
         注意两点：① 后端可能给字符串数字，所以先 Number 再比（只判 typeof number
         会让 "3" 漏标）；② 原写法 `null < 5` 为 true，会把空值也标红，故先判空。 */
      const n = Number(v);
      const low = !Number.isNaN(n) && n < 5;
      return <span className={low ? styles.lowRemain : undefined}>{v} 节</span>;
    },
  },
  { title: '手机号', dataIndex: 'phone', width: 160 },
  {
    title: '超过 7 天未上课',
    dataIndex: 'notClassDays',
    width: 160,
    render: (v) =>
      v === undefined || v === null || v === '' ? '--' : `${v} 天`,
  },
  {
    title: '操作',
    key: 'op',
    width: 110,
    render: (record) => (
      <MemberLink userId={record.userId}>会员档案</MemberLink>
    ),
  },
];
